import { useState } from "react";
import { Box, Typography, TextField, Grid, Paper, Button } from "@mui/material";
import OfficeVideo from "../assets/videos/officesContact.mp4";
import Swal from "sweetalert2";
import imgUrl from "../assets/images/imgUrl";

const Contact = () => {
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [showErrors, setShowErrors] = useState(false);
  const API_KEY = process.env.REACT_APP_SENDGRID_API_KEY;

  const handleSubmitEmail = () => {
    setShowErrors(true); // ✅ show validation errors now

    const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!isEmailValid || !subject || !message) {
      Swal.fire({
        icon: "warning",
        title: "Please fill all fields correctly before submitting.",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    fetch(process.env.REACT_APP_EMAIL_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        subject,
        message,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          return response.text().then((text) => {
            throw new Error(`Error ${response.status}: ${text}`);
          });
        }
        return response;
      })
      .then(() => {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Your email has been sent successfully!",
          showConfirmButton: false,
          timer: 2500,
        });

        // ✅ Clear form
        setEmail("");
        setSubject("");
        setMessage("");
        setShowErrors(false);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.error("Error sending email:", error);
      });
  };
  
  return (
    <>
    <Box sx={{ px: { xs: 2, md: 6 }, py: 6,  pt: "60px" , backgroundColor:"#fff" }} id="contact-us">
      <Grid container spacing={4} alignItems="center">
        {/* LEFT: Map and Office Info */}
        <Grid size={{ xs: 12, md: 6 }}>
          <Box position="relative">
            <video
              src={OfficeVideo}
              // controls
              autoPlay
              loop
              playsInline
              muted
              className="rounded-2xl shadow-lg w-100"
            />
          </Box>

          {/* Bottom label */}
          <Box sx={{ mt: 3 }}>
            <Typography
              variant="subtitle2"
              sx={{ color: "#69009f", fontWeight: "bold" }}
            >
              OFFICES
            </Typography>
            {/* <Typography variant="body2" sx={{ color: '#666' }}>
              Gain a real-time overview of the country’s health landscape
            </Typography> */}

              <div style={{
                backgroundColor: '#fff', marginLeft: "-20px"
              }} className="mobileViewcountries">
                <img
                  src={imgUrl.countriesListMobile}
                  alt="Countries List"
                  loading="lazy"
                  className="w-100"
                />
              </div>
          </Box>
        </Grid>

        {/* RIGHT: Contact Form */}
        <Grid size={{ xs: 12, md: 6 }}>
          <Paper
            elevation={3}
            sx={{
              borderRadius: 4,
              px: { xs: 2, md: 4 },
              py: 4,
              textAlign: "center",
              backgroundColor: "#f9f9f9",
            }}
            className="contactBox"
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: "#69009f",
                mb: 3,
                letterSpacing: "0.69px",
              }}
            >
              CONTACT US
            </Typography>

            <TextField
              fullWidth
              placeholder="Subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              variant="outlined"
              inputProps={{ maxLength: 78 }} // ✅ standard email subject length
              helperText={
                subject.length > 0 && `${subject.length}/78 characters`
              } // ✅ counter
              sx={{
                mb: 2,
                backgroundColor: "#fff",
                borderRadius: 2,
                "& .MuiOutlinedInput-root": { borderRadius: 2 },
              }}
            />

            <TextField
              fullWidth
              placeholder="Your Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              error={
                showErrors &&
                (email === "" || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
              }
              helperText={
                showErrors &&
                (email === ""
                  ? "Email is required"
                  : !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
                  ? "Please enter a valid email address"
                  : "")
              }
              variant="outlined"
              sx={{
                mb: 2,
                backgroundColor: "#fff",
                borderRadius: 2,
                "& .MuiOutlinedInput-root": { borderRadius: 2 },
              }}
            />

            <TextField
              fullWidth
              placeholder="Message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              multiline
              rows={4}
              variant="outlined"
              inputProps={{ maxLength: 500 }}
              error={showErrors && message.trim() === ""}
              helperText={
                showErrors && message.trim() === ""
                  ? "Message is required"
                  : message.length > 0 && `${message.length}/500 characters`
              }
              sx={{
                mb: 3,
                backgroundColor: "#fff",
                borderRadius: 2,
                "& .MuiOutlinedInput-root": { borderRadius: 2 },
              }}
            />

            <Button
              variant="contained"
              style={{
                borderRadius: 50,
                backgroundColor: "#69009f",
                color: !email || !subject || !message ? "#e0e0e0" : "#ffffff", // ✅ conditional text color
              }}
              onClick={handleSubmitEmail}
              disabled={!email || !subject || !message}
            >
              Submit
            </Button>
          </Paper>
        </Grid>
      </Grid>
    </Box>
    
      {/* <div style={{
        backgroundColor: '#fff',
        paddingLeft: '25px',
        paddingRight: '25px',
        paddingBottom: '20px'
      }} className="desktopViewcountries">
        <img
        src={imgUrl.countriesList}
        alt="Countries List"
        loading="lazy"
        className="w-100"
      />
      </div>

       <div style={{
        backgroundColor: '#fff',
        paddingLeft: '25px',
        paddingRight: '25px',
        paddingBottom: '20px'
      }}  className="mobileViewcountries">
        <img
        src={imgUrl.countriesListMobile}
        alt="Countries List"
        loading="lazy"
        className="w-100"
      />
      </div> */}
    
    </>
  );
};

export default Contact;
